import {errors as E} from '../../constants/errors';

export const checkRequiredValues = (values, errors) => {
  const required = {};

  for (let key in values) {
    const input = values[key];
    const emptyInput = !Boolean(input);
    const emptyValue = !emptyInput && (typeof input === 'object') && ('value' in input) && !Boolean(input.value);
    const invalidField = emptyInput || emptyValue;
    if (values.hasOwnProperty(key) && invalidField) required[key] = E.REQUIRED_FIELD;
  }

  return {
    ...errors,
    ...required
  }
};
